import { useTheme } from "capitalroadkit";
import React from "react";

const ConsolidationDetails = ({ ca, secondaryCa }) => {
  const theme = useTheme();

  return (
    <>
      <tr style={{ backgroundColor: theme.palette.background.main }}>
        <th>Listing currency</th>
        <td>{ca.listingCurrency}</td>
        <td>{secondaryCa?.listingCurrency}</td>
      </tr>
      <tr>
        <th>Fraction rounding</th>
        <td>{ca.fractionRounding}</td>
        <td>{secondaryCa?.fractionRounding}</td>
      </tr>
      <tr style={{ backgroundColor: theme.palette.background.main }}>
        <th>Ratio old</th>
        <td>{ca.ratioOld}</td>
        <td>{secondaryCa?.ratioOld}</td>
      </tr>
      <tr>
        <th>Ratio new</th>
        <td>{ca.ratioNew}</td>
        <td>{secondaryCa?.ratioNew}</td>
      </tr>
      <tr style={{ backgroundColor: theme.palette.background.main }}>
        <th>Action flag</th>
        <td>{ca.actionFlag}</td>
        <td>{secondaryCa?.actionFlag}</td>
      </tr>
      <tr>
        <th>Priority</th>
        <td>{ca.priority}</td>
        <td>{secondaryCa?.priority}</td>
      </tr>
    </>
  );
};

export default ConsolidationDetails;
